export default data => {
  let errors = {};

  if ( !data.email ) errors.email = 'Вкажіть email.';

  if ( !data.profession ) errors.profession = 'Вкажіть вид діяльності.';

  return errors;
}
